import React from 'react'

import IconArrowRight from '@/icons/navigation/iconArrowRight'
import classNames from 'classnames'

import * as styles from './Breadcrumbs.css'

type BreadcrumbsProps = {
  list: {
    label?: string
    link?: string
    active?: boolean
  }[]
  color?: 'brand' | 'moss'
  isDark?: boolean
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  list,
  color = 'brand',
  isDark = false,
}) => {
  const ActiveLinkClassName = classNames({
    [styles.Link]: true,
    [styles.LinkDark]: isDark,
    [styles.ActiveLinkBrand]: color === 'brand',
    [styles.ActiveLinkMoss]: color === 'moss',
  })

  return (
    <div className={styles.BreadcrumbsContent}>
      <ol className={styles.BreadcrumbsItem}>
        {list.map((crumb, i) => (
          <li className={styles.BreadcrumbsItem} key={`${crumb.label}-${i}`}>
            <a
              className={
                crumb.active
                  ? ActiveLinkClassName
                  : `${styles.Link} ${isDark ? styles.LinkDark : ''}`
              }
              href={crumb.link}
            >
              <span>{crumb.label}</span>
            </a>
            {list.length - 1 > i && (
              <IconArrowRight
                className={
                  isDark ? styles.BreadcrumbsIconDark : styles.BreadcrumbsIcon
                }
              />
            )}
          </li>
        ))}
      </ol>
    </div>
  )
}

export default Breadcrumbs
